import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';
@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(
    private http: HttpClient,
  ) { }

  getPost():Observable<any>{
    return this.http.get(Services.posts).pipe(
      tap(posts => console.info(`fetched posts Home`))
    );
  }


}
